import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useCBBannerLang } from './useCBBannerLang';
import { chromeBrowserBannerService } from 'features/startup-notifications/chrome-browser-banner/infra';

import type { MissingContent } from 'features/startup-notifications/chrome-browser-banner/domain';

export function useCBBanner() {
  const [isShowed, setIsShowed] = useState(false);
  const [missingContent, setMissingContent] = useState<MissingContent>('NONE');

  const partnerId = useSelector((s: any) => s.partnerReducer.profile.id);

  const lang = useCBBannerLang();

  const handleCTA = () => {
    chromeBrowserBannerService.goToInstall({
      partnerId,
      missingContent,
    });
  };

  const handleClose = () => {
    setIsShowed(false);
    chromeBrowserBannerService.closeBanner({
      partnerId,
      missingContent,
    });
  };

  useEffect(() => {
    if (partnerId) {
      chromeBrowserBannerService.setup({ partnerId }).then(resp => {
        const { isMobileDevice, isChromeBrowser, hasChromeExtension } = resp;
        if (isMobileDevice) setIsShowed(false);
        else if (!isChromeBrowser) {
          setIsShowed(true);
          setMissingContent('BROWSER');
        } else if (!hasChromeExtension) {
          setIsShowed(true);
          setMissingContent('EXTENSION');
        }
      });
    }
  }, [partnerId]);

  return {
    lang,
    isShowed,
    handleCTA,
    handleClose,
  };
}
